import {HOURLY_ANALYSER_URL} from "../../config/constants";
import { thirdPartyPostRequest,  } from '../API'
/*********************************************************
* Function Name : getCrunchSettings
* Description   : Get crunch settings
*********************************************************/
export const getCrunchSettings = async (options) =>{
    try {
        const params = {
            url : `${HOURLY_ANALYSER_URL}api/crunchsettings`,
            headers : {
                "auth" : "565gfh34556rrr5fSjUmArpeck7876867444",
                "Content-Type" : "application/x-www-form-urlencoded"
            },
            postData : options  
        }
        const res = await thirdPartyPostRequest(params);

        if(res.status === true || res.status === 200){
            console.log("RESPONSE : ", res);
            return {status : true, result : res?.data};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function